export default "__VITE_ASSET__BI6Lmsay__"